import React, { Component } from 'react'

import { connect } from 'react-redux'

import Collapse from './Collapse'
import CheckboxLine from './CheckboxLine'
import InputCounter from './InputCounter'
import Table from './Table'
import HeaderTitle from './HeaderTitle'

import { selectDialingPlan, 
    updateDialingPlanQuantity, addReduceDialingPlanQuantity } from '../store/actions/DialingPlansActions'

import { limitNumTo2AfterDot } from '../utils/main'

class DialingPlan extends Component {

    state = {
        isComparePbxOpened: false,
    }

    selectDialingPlan(isUnlimited, planId, planPrice) {
        this.props.selectDialingPlan(isUnlimited, planId, planPrice);
    }

    updateDialingPlanQuantity(value) {
        this.props.updateDialingPlanQuantity(value);
    }

    addReduceDialingPlanQuantity(isAdding) {
        this.props.addReduceDialingPlanQuantity(isAdding);
    }

    toggleComparePbx(e) {
        e.stopPropagation();
        this.setState({
            ...this.state,
            isComparePbxOpened: !this.state.isComparePbxOpened,
        })
    }
    
    render() {
        const { DialingPlan } = this.props.DialingPlansReducer;
        const { isComparePbxOpened } = this.state;

        const yes = <i className="fas fa-check"></i>;
        const no = "";//<i className="fas fa-times"></i>;
        const pbxFeatures = (
            <Table title="PBX Features" items={[
                ["PBX Features", "1-4 Users", "5 and Up", "Dedicated"],
                ["Call Transfer/Forwarding", yes, yes, yes],
                ["Voicemail/Voicemail to Email", yes, yes, yes],
                ["Follow Me", yes, yes, yes],
                ["Auto-Attendant/IVR", yes, yes, yes],
                ["Do Not Disturb", yes, yes, yes],
                ["Ext. to Ext. calling", yes, yes, yes],
                ["Music On Hold", yes, yes, yes],
                ["Office Hours", yes, yes, yes],
                ["Remote Users", yes, yes, yes],
                ["Multiple Offices", yes, yes, yes],
                ["Call Parking", no, yes, yes],
                ["Call Queue", no, yes, yes],
                ["Ring Groups", no, yes, yes],
                ["Call Reporting", no, yes, yes],
                ["Caller ID", no, yes, yes],
                ["Phone Directory", no, yes, yes],
                ["Conference Rooms", no, yes, yes],
                ["call Recordings", no, "$20/month", "$20/month"],
                ["and much more…", no, yes, yes],
            ]} />
        );
        const unlimited = (
            <div>
                <CheckboxLine content={
                    [<div>Extensions with Unlimited In & out Minutes</div>]
                    }
                    checkboxProps={{
                        //title: "$19.99/month", 
                        active: DialingPlan.id == "UNLIMITED", 
                        onChange: () => { this.selectDialingPlan(true, "UNLIMITED", 24.99) }
                    }}
                    /*checkboxProps={{
                        //title: "$24.99/month", 
                        active: DialingPlan.id == "UNLIMITED", 
                        onChange: () => { this.selectDialingPlan(true, "UNLIMITED", 24.99) }
                }}*/ />
                <CheckboxLine content={
                    [
                        <i>* 1 to 4 Ext. = $24.99/month, 5 or more = $19.99/month</i>,
                        <InputCounter 
                            onAdd={() => this.addReduceDialingPlanQuantity(true)}
                            onReduce={() => this.addReduceDialingPlanQuantity(false)}
                            onChange={(e) => this.updateDialingPlanQuantity(e.target.value)}
                            value={DialingPlan.quantity}
                            placeholder="Quantity"
                            inputStyle={{background: (!DialingPlan.quantity && DialingPlan.id == "UNLIMITED" ? "rgb(255,255,111)" : "")}}
                        />
                    ]
                    }
                    hideCheckbox={true}
                    /*checkboxProps={{
                        //title: "$19.99/month", 
                        active: DialingPlan.id == "UNLIMITED", 
                        onChange: () => { this.selectDialingPlan(true, "UNLIMITED", 24.99) }
                    }}*/
                />
                <div style={{textAlign: "right", marginBottom: "15px", fontSize: "1.15rem"}}>
                    ${limitNumTo2AfterDot(DialingPlan.quantity * (DialingPlan.quantity >= 5 ? 19.99 : 24.99))}
                    /month
                </div>
                {/*<CheckboxLine content={
                    [<div>Pay as you go</div>,
                    <div>$0.03/minute in & out</div>]}
                    checkboxProps={{
                        title: "$10.00/month",
                        active: DialingPlan.id == "UNLIMITED_PAY_AS_U_GO", 
                        onChange: () => { this.selectDialingPlan(true, "UNLIMITED_PAY_AS_U_GO") }
                }} />*/}
                {isComparePbxOpened && pbxFeatures}
            </div>
        );
        const metered = (
            <div>
                {/*<CheckboxLine content={
                    [<div>Incoming (Local) minutes</div>,
                    <div>$0.007/Minute</div>]
                    }
                    checkboxProps={{
                        title: "$100.00/month", 
                        active: DialingPlan.id == "IN_LOCAL", 
                        onChange: () => { this.selectDialingPlan(true, "IN_LOCAL") }
                }} />*/}
                <div style={{margin: "15px auto"}}>
                    <i>
                        * Incoming: local: $0.007/Minute, TF: $0.015/minute
                    </i>
                </div>
                {/*<CheckboxLine content={
                    [<div>Incoming Local & Toll Free Minutes</div>,
                    <div>$0.007/Minute & $0.015/minute</div>]
                    }
                    checkboxProps={{
                        title: "$100.00/month", 
                        active: DialingPlan.id == "IN_LOCAL_AND_TOLL", 
                        onChange: () => { this.selectDialingPlan(true, "IN_LOCAL_AND_TOLL") }
                }} />
                <CheckboxLine content={
                    [<div>Unlimited Local-Incoming Trunk/s (1 call per trunk, non toll free)</div>,
                    <i>* For Dedicated or SIP Trunk solutions</i>]
                    }
                    checkboxProps={{
                        title: "$9.99/month", 
                        active: DialingPlan.id == "UNLIMITED_IN_LOCAL_TRUNK", 
                        onChange: () => { this.selectDialingPlan(true, "UNLIMITED_IN_LOCAL_TRUNK") }
                }} />*/}
                <CheckboxLine content={
                    [<div>Pay as you go</div>,
                    <div>$0.03/minute in & out</div>]
                    }
                    checkboxProps={{
                        title: "$10.00/month", 
                        active: DialingPlan.id == "PAY_AS_YOU_GO", 
                        onChange: () => { this.selectDialingPlan(false, "PAY_AS_YOU_GO", 10.00) }
                }} />
                <CheckboxLine content={
                    [<div>Outbound Small Office</div>,
                    <div>$0.0150/minute*</div>]
                    }
                    checkboxProps={{
                        title: "$150.00/month", 
                        active: DialingPlan.id == "OUTBOUND_SMALL_OFFICE", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_SMALL_OFFICE", 150.00) }
                }} />
                <CheckboxLine content={
                    [<div>Outbound Saving</div>,
                    <div>$0.0099/minute*</div>]
                    }
                    checkboxProps={{
                        title: "$250.00/month", 
                        active: DialingPlan.id == "OUTBOUND_BASIC", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_BASIC", 250.00) }
                }} />
                <CheckboxLine content={
                    [<div>Outbound Pro</div>,
                    <div>$0.0079/minute*</div>]
                    }
                    checkboxProps={{
                        title: "$500.00/month", 
                        active: DialingPlan.id == "OUTBOUND_PRO", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_PRO", 500.00) }
                }} />
                {/* <CheckboxLine content={
                    [<div>Outbound Calling - Blended</div>,
                    <div>Blended* (Download Rates)</div>]
                    }
                    checkboxProps={{
                        title: "$1,000.00/month", 
                        active: DialingPlan.id == "OUTBOUND_CALLING_BLENDED", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_CALLING_BLENDED", 1000.00) }
                }} /> */}
                <hr style={{margin:"1.5rem .75rem", color: "#74747494"}} />
                <CheckboxLine content={
                    [<div>Outbound - <u>Dialer</u> Flat</div>,
                    <div>$0.0079/minute*</div>]
                    }
                    checkboxProps={{
                        title: "$100.00/month", 
                        active: DialingPlan.id == "OUTBOUND_DIALER_FLAT", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_DIALER_FLAT", 100.00) }
                }} />
                <CheckboxLine content={
                    [<div>Outbound - <u>Dialer</u> Max</div>,
                    <div>Blended* (Download Rates)</div>]
                    }
                    checkboxProps={{
                        title: "$500.00/month", 
                        active: DialingPlan.id == "OUTBOUND_DIALER", 
                        onChange: () => { this.selectDialingPlan(false, "OUTBOUND_DIALER", 500.00) }
                }} />
            </div>
        );
        
        return (
            <div>
                <Collapse defaultActiveKey={["0", "1"]} items={[
                    {headerTitle: 
                        <HeaderTitle 
                            titleLeft={<div>Extensions with <b>Unlimited In & out Minutes</b></div>} 
                            titleRight={
                                <div 
                                    style={{borderBottom: "2.5px solid"}}
                                    onClick={(e) => this.toggleComparePbx(e)}>
                                    Compare
                                </div>
                            }
                        />, 
                        content: unlimited}, 
                    {headerTitle: <div><b>Metered Usage - SIP Trunks</b>, Unlimited concurrent calls</div>, 
                        content: metered},
                ]} />
                <div>
                    <i>* Plans are changeable after login</i>
                </div>
                <div>
                    <i>** Sending dialer calls through non-dialer plans are not allowed and will result in a charge of $0.05/minute and possible cancellation of the account</i>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        DialingPlansReducer: state.DialingPlansReducer,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        selectDialingPlan: (isUnlimited, planId, planPrice) => dispatch(selectDialingPlan(isUnlimited, planId, planPrice)),
        updateDialingPlanQuantity: (newQty) => dispatch(updateDialingPlanQuantity(newQty)),
        addReduceDialingPlanQuantity: (isAdding) => dispatch(addReduceDialingPlanQuantity(isAdding)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DialingPlan);